import { FooterBubbles } from "@/components/site/FooterBubbles";
import { FooterCallout } from "./footer/FooterCallout";
import { FooterColumns } from "./footer/FooterColumns";
import { FooterBottom } from "./footer/FooterBottom";

export const Footer = () => (
  <footer className="relative overflow-hidden bg-ink text-ink-foreground">
    <FooterBubbles />
    <div className="container-wide relative z-10 py-20">
      <div className="grid gap-16 lg:grid-cols-12">
        <FooterCallout />
        <FooterColumns />
      </div>
      <FooterBottom />
    </div>
  </footer>
);
